import { render, staticRenderFns } from "./CharacterSheetEquipment.vue?vue&type=template&id=8f887efe&lang=pug&"
import script from "./CharacterSheetEquipment.vue?vue&type=script&lang=ts&"
export * from "./CharacterSheetEquipment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanels})
